import { createFileRoute } from '@tanstack/react-router'
import { AuthErrorPage } from '../components/pages/AuthErrorPage'

export const Route = createFileRoute('/auth-error')({
  component: () => <AuthErrorPage />
})